import {
	type ClientPropertyCottageDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CottageFormFields } from "web_myplann/Portfolio/Forms/CottageForm/CottageFormFields";
import { useEditCottageForm } from "web_myplann/Portfolio/Forms/CottageForm/useEditCottageForm";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditCottageFormProps = {
	propertyId: number;
	property: ClientPropertyCottageDetailResponseDTO;
	detailRoute: string;
};

export const EditCottageForm = ({
	propertyId,
	property,
	detailRoute,
}: EditCottageFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditCottageForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<RealEstateTypeRow mode="locked" value={ClientPropertyTypeEnum.Cottage} />
			<CottageFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
